module.exports = __webpack_public_path__ + "img/202410_07.35a3e50f.jpg";